
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'escapeHtml', pure: false })
export class ModulesEscapeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(content) {
    return(content ? this.sanitizer.bypassSecurityTrustHtml(content) : '');
  }
}